<template>
    <div class="about">
        <page-cover image-url="/images/about/cover.jpg" :overlay="false" />
        <section>
            <div class="px-4 lg:px-12 md:container md:mx-auto py-12 lg:py-32">
                <div class="text-center">
                    <h1 class="page-title text-primary">About Us</h1>
                    <p class="mt-8">Our goal is to link talented early years candidates looking for meaningful employment and children’s daycare nursery settings in need of skilled professionals. We also act as the gateway for individuals looking to work in the Early Years sector.</p>
                </div>
                <p class="text-lg text-center mt-4">At Early Years recruitment, we are dedicated to connecting exceptional candidates with quality childcare providers. We fully understand the crucial role that early years education plays in shaping a child’s future, and we are passionate about ensuring that every child receives the highest level of childcare and education during their early years.</p>
                <h3 class="text-primary text-center text-3xl font-semibold mt-12">We Believe In</h3>
                <p class="text-lg text-center mt-8">Our mission is to link talented early years candidates looking for meaningful employment and children’s daycare nursery settings in need of skilled professionals.</p>
                <p class="text-lg text-center mt-4">We believe that when passionate and qualified educators are placed in nurturing environments, children thrive and reach their full potential.</p>
            </div>
        </section>
        <section class="section-bg">
            <div class="px-4 lg:px-12 md:container md:mx-auto py-12 lg:py-32">
                <div class="grid lg:grid-cols-2 gap-12 items-center">
                    <div class="image-wrapper">
                        <BgImage src="/images/about/vision.jpg" alt="Our Vision" />
                    </div>
                    <div>
                        <h3 class="text-primary text-3xl font-semibold">Our Vision</h3>
                        <p class="mt-6">At Early Years recruitment, our vision is to be UK’s Recruitment Agency of choice, connecting exceptional candidates with quality childcare providers. We aim to provide our Clients and Candidates with a flexible, supportive, transparent and trusted service.</p>
                    </div>
                </div>
            </div>
        </section>
        <section>
            <div class="px-4 lg:px-12 md:container md:mx-auto py-12 lg:py-32">
                <div class="grid lg:grid-cols-2 gap-12 items-center">
                    <div class="row-start-2 lg:row-start-auto">
                        <h3 class="text-primary text-3xl font-semibold">Our Approach</h3>
                        <p class="mt-6">At Early Years recruitment, we take a comprehensive and personalised approach to ensuring that we meet the unique needs of both candidates and childcare providers. Our approach is centered around three key principles:</p>
                        <ul class="mt-4">
                            <li>- Careful selection and screening</li>
                            <li>- personalised matching</li>
                            <li>- Ongoing support and development</li>
                        </ul>
                        <p class="mt-4">At Early Years recruitment, our approach is centered around finding the perfect match between candidates and childcare providers.</p>
                    </div>
                    <div class="image-wrapper">
                        <BgImage src="/images/about/approach.jpg" alt="Our Approach" />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script setup>
useHead({
    title: 'About Us',
    link: [
        { rel: 'preload', as: 'image', href: '/images/about/cover.jpg', fetchpriority: 'high' },
    ],
});
</script>

<style lang="scss" scoped>
.about {
    .image-wrapper {
        position: relative;
        height: 400px;
        @media (max-width: 767px), (min-device-width: 375px) and (max-device-width: 812px) and (-webkit-min-device-pixel-ratio: 3) {
           height: 250px;
        }
    }
}
</style>